"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CulliganGlobalFilter = exports.State = void 0;
const effect_1 = require("effect");
const volume_1 = require("../../../../../unit/volume");
const _util_1 = require("./_util");
const Definition = __importStar(require("./common"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.CulliganGlobalFilter';
const TAG = 'CulliganGlobalFilter';
const LABEL = 'Culligan Global Filter';
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.ExpendableState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class CulliganGlobalFilter extends Definition.ExpendableInLiters.extend(`${NAMESPACE}.${TAG}`)({ _tag: effect_1.Schema.tag(TAG), ...Definition.Fields }, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
}) {
    static id = 'filter';
    static label = LABEL;
    static category = Definition.Category.Filter;
    static expirable = false;
    static hasBatch = false;
    static State = exports.State;
    static catalogue = {
        flt_wr_carbon: this.make({
            id: 'flt_wr_carbon',
            name: 'Wrap Carbon Filter',
            rangeTrigger: volume_1.Liter.make({ amount: 11_355 * 0.75 }),
            rangeExhaust: volume_1.Liter.make({ amount: 11_355 }),
        }),
        flt_hp_block: this.make({
            id: 'flt_hp_block',
            name: 'HP Block Filter',
            rangeTrigger: volume_1.Liter.make({ amount: 11_355 * 0.75 }),
            rangeExhaust: volume_1.Liter.make({ amount: 11_355 }),
        }),
        flt_cb_remin: this.make({
            id: 'flt_cb_remin',
            name: 'Remin CB Filter',
            rangeTrigger: volume_1.Liter.make({ amount: 7_570 * 0.75 }),
            rangeExhaust: volume_1.Liter.make({ amount: 7_570 }),
        }),
        flt_ro_remin: this.make({
            id: 'flt_ro_remin',
            name: 'Remin RO Filter',
            rangeTrigger: volume_1.Liter.make({ amount: 7_570 * 0.75 }),
            rangeExhaust: volume_1.Liter.make({ amount: 7_570 }),
        }),
    };
    static legacyCatalogueItemIdMap = {};
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
}
exports.CulliganGlobalFilter = CulliganGlobalFilter;
Definition.satisfiesConstructor(CulliganGlobalFilter);
//# sourceMappingURL=culligan-global-filter.js.map